import { Anchor } from '@repo/ui/src/components/Anchor';

export interface JobProps {
  absolute_url: string;
  location: string;
  title: string;
}

const Job = ({ absolute_url, location, title }: JobProps) => (
  <li className="tw-text-center tw-mb-6">
    <Anchor
      className="tra-text-web-body-xl tw-underline tw-font-bold"
      externalLink={absolute_url}
      isExternal
    >
      {title}
    </Anchor>
    <p className="tra-text-web-body-xl">{location}</p>
  </li>
);

export default Job;
